/* variant-shipping.js — plazo de envío POR VARIANTE (kallfu, 5-ago-2026)

   El tag de plazo (hoy/3days/5days…) es del PRODUCTO, así que en un producto con
   varias variantes no se puede decir "esta variante llega hoy y las demás no".
   Solución: la variante lleva el metafield custom.plazo_variante; Liquid pinta un
   bloque oculto por cada variante que lo tenga, y este componente muestra el que
   corresponde a la variante elegida (o el del producto si esa variante no tiene).   */
class VariantShipping extends HTMLElement {
  connectedCallback() {
    this.def = this.querySelector('[data-ship-default]');
    this.esp = Array.from(this.querySelectorAll('[data-ship-variant]'));
    if (!this.esp.length) return;               // producto sin excepciones: no hace nada
    this.sync();
    // el tema reescribe el input[name=id] al cambiar variante; escuchamos ambos caminos
    document.addEventListener('change', () => this.pronto(), true);
    document.addEventListener('variant:change', () => this.pronto());
    window.addEventListener('popstate', () => this.pronto());
    const input = this.input();
    if (input && window.MutationObserver) {
      new MutationObserver(() => this.sync()).observe(input, { attributes: true, attributeFilter: ['value'] });
    }
  }
  input() {
    return document.querySelector('form[action*="/cart/add"] input[name="id"]');
  }
  idActual() {
    const i = this.input();
    if (i && i.value) return String(i.value);
    const u = new URL(window.location.href).searchParams.get('variant');
    return u ? String(u) : null;
  }
  pronto() { clearTimeout(this._t); this._t = setTimeout(() => this.sync(), 250); }
  sync() {
    const id = this.idActual();
    let hay = false;
    this.esp.forEach((b) => {
      const match = b.dataset.shipVariant === id;
      b.hidden = !match;
      if (match) hay = true;
    });
    if (this.def) this.def.hidden = hay;
  }
}
if (!customElements.get('variant-shipping')) customElements.define('variant-shipping', VariantShipping);
